import MuiButton from '@mui/material/Button'
import { MouseEvent } from 'react'
import styles from './Button.module.scss'

import { getButtonStyles } from './Button.styles'
import IconButton from '../IconButton/IconButton'

export interface ButtonProps {
  onClick: (event?: MouseEvent<HTMLElement>) => void
  label: string | JSX.Element
  variant: 'text' | 'outlined' | 'contained'
  color: 'primary' | 'secondary'
  mobile?: boolean
  textAlignment?: 'left' | 'center' | 'right'
  icon?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  maxWidth?: boolean
  form?: string
  iconLocation?: 'left' | 'right'
  width?: string
  showDeleteIcon?: boolean
  onDelete?: () => void
}

function Button(props: ButtonProps) {
  const {
    onClick,
    label,
    type,
    disabled,
    variant,
    color,
    mobile,
    textAlignment,
    icon,
    maxWidth,
    form,
    iconLocation = 'left',
    width,
    showDeleteIcon,
    onDelete
  } = props

  const buttonStyles = getButtonStyles(color, variant)

  const hadleOnClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault()
    onClick(e)
  }

  const handleDelete = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    e.preventDefault()
    if (onDelete) {
      onDelete()
    }
  }

  const buttonWidth = width || (maxWidth ? '100%' : 'fit-content')

  return (
    <MuiButton
      className={`${styles.buttonComponent} ${
        mobile ? styles.buttonMobile : ''
      }`}
      onClick={hadleOnClick}
      disabled={disabled}
      type={type || 'button'}
      variant={variant}
      color={color}
      sx={{
        ...buttonStyles,
        justifyContent: textAlignment || 'center',
        width: buttonWidth
      }}
      disableRipple
      form={form}
    >
      {icon && iconLocation === 'left' ? (
        <i className={`${icon} ${styles.buttonIcon}`} />
      ) : null}
      {typeof label === 'string' ? (
        <p
          className={`${styles.buttonLabel} ${
            mobile ? 'body-bold-large' : 'body-bold-small'
          } `}
        >
          {label}
        </p>
      ) : (
        label
      )}
      {icon && iconLocation === 'right' ? <i className={`${icon}`} /> : null}
      {showDeleteIcon && onDelete ? (
        <span
          className={styles.deleteIconWrapper}
          role="button"
          tabIndex={0}
          onClick={handleDelete}
          onMouseDown={e => e.stopPropagation()}
          onTouchStart={e => e.stopPropagation()}
          onTouchEnd={e => {
            e.stopPropagation()
            handleDelete(e as unknown as MouseEvent<HTMLElement>)
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.stopPropagation()
              handleDelete(e as unknown as MouseEvent<HTMLElement>)
            }
          }}
        >
          <IconButton
            icon="las la-times icon-big"
            onClick={handleDelete}
            color="primary"
            disabled={disabled}
            variant="contained"
          />
        </span>
      ) : null}
    </MuiButton>
  )
}

export default Button
